<template>
    <div class="card">
        <img
            v-if="options.image"
            :src="$i18n.locale + '/images/' + options.image"
        />
        <span class="chapter-title" v-html="options.chapterTitle"> </span>
    </div>
</template>

<script>
export default {
    name: "ChapterCard",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    height: 250px;
    background-color: white;
    padding: 0.3rem 0.3rem 2.5rem 0.3rem;
    color: $resolution_blue;
    text-transform: uppercase;
    text-align: center;

    @media (max-width: 1536px) {
        padding: 0.3rem 0.3rem 2rem 0.3rem;
        height: 140px;
    }
    @media (max-width: 768px) {
        height: 200px;
    }
    .chapter-title {
        // padding: 2px 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: bold;
        @media (max-width: 1536px) {
            font-size: 9px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
